<header>
  <div class="topbar d-flex align-items-center">
    <nav class="navbar navbar-expand ps-0">
      <nav aria-label="breadcrumb" class="d-none d-sm-none d-md-block">
        <div class="ms-auto" (click)="toggleIsExpanded()" [class.rotate]="!isWaterAnimationActive"
          [class.water-animation]="isWaterAnimationActive">
          <div class="toggle-icon">{{ isExpanded ? "<" : ">" }}</div>
          </div>
          <ol class="breadcrumb mb-0 p-0 d-none">
            <li class="breadcrumb-item">
              <a href="javascript:;"><i class="bx bx-home-alt"></i></a>
            </li>
            <li class="breadcrumb-item active" style="font-size: 15px" aria-current="page">
              Dashboard
            </li>
          </ol>
      </nav>
      <div class="mobile-toggle-menu ms-auto"><i class="bx bx-menu"></i></div>

      <div class="search-bar flex-grow-1">
        <div class="position-relative search-bar-box">
          <input type="text" class="form-control search-control" placeholder="Type to search..." />
          <span class="position-absolute top-50 search-show translate-middle-y"><i class="bx bx-search"></i></span>
          <span class="position-absolute top-50 search-close translate-middle-y"><i class="bx bx-x"></i></span>
        </div>
      </div>

      <div class="text-center col-md-8 scrolling-bottom-container">
        <div *ngIf="!['1','4','10','5'].includes(ROLEID)">
          <div class="scrolling-wrapper">
            <div class="scrolling-text">
              <b>{{ getAccessingText() }}</b>
            </div>
          </div>
        </div>
      </div>
      <div class="top-menu ms-auto">
        <ul class="navbar-nav align-items-center">
          <div *ngIf="!['1','4','10','5'].includes(ROLEID)">
            <select class="form-select" [(ngModel)]="SchoolLevelId" (change)="changeSchool($event)">
              <option *ngFor="let item of SchoolList" [value]="item.LEVEL_ID">
                {{ item.LEVEL_NAME }}
              </option>
            </select>
          </div>
          &nbsp;
          <div *ngIf="ROLEID != '1'">
            <select class="form-select" [(ngModel)]="selectedModule" (change)="changeRoles($event)">
              <option *ngFor="let item of roles" [value]="item.ROLE_ID">
                {{ item.ROLE_NAME }}
              </option>
            </select>
          </div>
          <li class="nav-item dropdown dropdown-large d-none">
            <a class="nav-link dropdown-toggle dropdown-toggle-nocaret position-relative" href="#" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              <span class="alert-count">{{
                getUnViewdNotificationCount()
                }}</span>
              <i class="bx bxs-bell"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <a href="javascript:;">
                <div class="msg-header">
                  <p class="msg-header-title">Notifications</p>
                </div>
              </a>
              <div style="overflow-y: auto; height: 360px">
                <div class="header-notifications-list" *ngFor="let item of notification">
                  <a class="dropdown-item" data-bs-toggle="modal" (click)="viewNotification(item.ID)"
                    data-bs-target="#myNoti" href="javascript:;">
                    <div class="d-flex align-items-center">
                      <div class="bg-light-primary text-primary">
                        <i class="bx bx-group notify"></i>
                      </div>
                      <div>
                        <div class="flex-grow-1">
                          <h6 class="msg-name html" id="message" [innerHTML]="item.SUBJECT"></h6>
                          <p class="msg-info html" [innerHTML]="item.notification_type"></p>
                          <p class="msg-info html" [innerHTML]="item.notification_body"></p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <a href="javascript:;">
                <div class="text-center msg-footer" (click)="viewMessage('0')" data-bs-toggle="modal"
                  data-bs-target="#myNoti">
                  View All
                </div>
              </a>
            </div>
          </li>
        </ul>
      </div>

      <div class="user-box dropdown">
        <a class="d-flex align-items-center nav-link dropdown-toggle dropdown-toggle-nocaret" href="#" role="button"
          data-bs-toggle="dropdown" aria-expanded="false">
          <img *ngIf="ROLEID != '3'" src="https://i.pinimg.com/736x/89/90/48/899048ab0cc455154006fdb9676964b3.jpg"
            class="user-img" alt="user avatar" />
          <img *ngIf="ROLEID == '3'" [src]="
              userDetails?.result?.upload_4 == null
                ? '../../assets/images/defaultProfile.png'
                : url + userDetails?.result?.upload_4
            " class="user-img" alt="user avatar" />
          <div class="user-info ps-3">
            <p class="user-name mb-0">{{ userName }}</p>
            <p class="designattion mb-0">{{ roleName=="Admin"?"HOI": roleName}}</p>
          </div>
          &nbsp;&nbsp;
        </a>
        <button class="power-btn" (click)="Signout()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-power"
            viewBox="0 0 16 16">
            <path d="M7.5 1v7h1V1z" />
            <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812" />
          </svg>
        </button>

        <ul class="dropdown-menu dropdown-menu-end">
          <li>
            <a class="dropdown-item" (click)="navigateToDashboard()"><i
                class="bx bx-home-circle"></i><span>Dashboard</span></a>
          </li>
          <li *ngIf="ROLEID == '3'" (click)="profileNavigate('user')">
            <a class="dropdown-item" href="javascript:;"><i class="bx bx-user"></i><span>Profile</span></a>
          </li>
          <li *ngIf="ROLEID == '1'">
            <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal" (click)="LoadProfileDetails()"
              data-bs-target="#editInstitutionModal">
              <i class="bx bx-user"></i><span>Profile</span></a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal" (click)="getOldPassword()"
              data-bs-target="#changePassword">
              <i class="bx bx-key"></i><span>Change Password</span></a>
          </li>

          <li>
            <div class="dropdown-divider mb-0"></div>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:;" id="logOut" (click)="Signout()"><i
                class="bx bx-log-out-circle"></i><span>Logout</span></a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</header>

<div class="modal" id="myNoti" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0 w-100">Notification</h5>
        <button type="button" (click)="close()" class="close" aria-label="Close" data-bs-dismiss="modal">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body" *ngFor="let item of viewNoti">
        <h4 class="msg-name html" id="htmldiv" [innerHTML]="item.SUBJECT"></h4>
        <hr />
        <h6 class="msg-info html" id="htmldiv1" [innerHTML]="item.notification_type"></h6>
        <p class="msg-info html" id="htmldiv2" [innerHTML]="item.notification_body"></p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger" id="Noti_close" (click)="close()" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="changePassword" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header py-2">
        <h4 class="modal-title w-100">Change Password</h4>
        <button type="button" (click)="close1()" class="close" data-bs-dismiss="modal">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <form class="well form-horizontal" [formGroup]="myForm" (ngSubmit)="ChangePass(myForm)">
          <fieldset>
            <div class="form-group row">
              <label class="col-md-4 control-label line_2 rem_1">
                Old Password<span class="text-danger">*</span></label>
              <div class="col-md-8 inputGroupContainer">
                <div class="input-group">
                  <strong>:</strong> &nbsp;
                  <input placeholder="" type="password" class="form-control" formControlName="oldPassword"
                    (keydown.space)="$event.preventDefault()" />
                </div>
                <div *ngIf="myForm.get('oldPassword').touched">
                  <span class="text-danger" *ngIf="myForm.get('oldPassword').hasError('required')">
                    This field is required.
                  </span>
                  <span class="text-danger" *ngIf="myForm.get('oldPassword').hasError('minlength')">
                    password minimum 6 characters.
                  </span>
                </div>
              </div>
            </div>
            &nbsp;&nbsp;
            <div class="form-group row">
              <label class="col-md-4 control-label line_2 rem_1">
                New Password<span class="text-danger">*</span></label>
              <div class="col-md-8 inputGroupContainer">
                <div class="input-group">
                  <strong>:</strong> &nbsp;
                  <input placeholder="" type="password" class="form-control" formControlName="password"
                    (keydown.space)="$event.preventDefault()" />
                </div>
                <div *ngIf="myForm.get('password').touched">
                  <span class="text-danger" *ngIf="myForm.get('password').hasError('required')">
                    This field is required.
                  </span>
                  <span class="text-danger" *ngIf="myForm.get('password').hasError('minlength')">
                    password minimum 6 characters.
                  </span>
                </div>
              </div>
            </div>
            &nbsp;&nbsp;
            <div class="form-group row">
              <label class="col-md-4 control-label line_2 rem_1">
                Confirm Password<span class="text-danger">*</span></label>
              <div class="col-md-8 inputGroupContainer">
                <div class="input-group">
                  <strong>:</strong> &nbsp;
                  <input placeholder="" type="password" class="form-control" formControlName="confirmPassword"
                    (change)="passwordCheck()" (keydown.space)="$event.preventDefault()" />
                </div>
                <div *ngIf="myForm.get('confirmPassword').touched">
                  <span class="text-danger" *ngIf="myForm.get('confirmPassword').hasError('required')">
                    This field is required.
                  </span>
                  <span class="text-danger" *ngIf="myForm.get('confirmPassword').hasError('minlength')">
                    password minimum 6 characters.
                  </span>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-save" (click)="ChangePass(myForm)" [disabled]="myForm.invalid">
          Change Password
        </button>
        <button type="button" class="btn btn-danger" id="passPopupClose" (click)="close1()" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Institution Modal (for Role ID = 1) with Tabs -->
<div class="modal fade" id="editInstitutionModal" tabindex="-1" aria-labelledby="editInstitutionModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-primary" id="editInstitutionModalLabel">Edit Institution - {{ editData?.TNT_NAME }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeEditModal()"></button>
      </div>
      <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
        <!-- Tab Navigation -->
        <ul class="nav nav-tabs" id="institutionTabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="institution-details-tab" data-bs-toggle="tab"
              data-bs-target="#institution-details" type="button" role="tab" aria-controls="institution-details"
              aria-selected="true" (click)="activeTab = 'details'">
              <i class="fas fa-building me-1"></i> Institution Details
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="logo-upload-tab" data-bs-toggle="tab" data-bs-target="#logo-upload"
              type="button" role="tab" aria-controls="logo-upload" aria-selected="false" (click)="activeTab = 'logo'">
              <i class="fas fa-image me-1"></i> Logo Upload
            </button>
          </li>
        </ul>

        <form #editForm="ngForm">
          <!-- Tab Content -->
          <div class="tab-content pt-3" id="institutionTabsContent">
            <!-- Tab 1: Institution Details (editable) -->
            <div class="tab-pane fade show active" id="institution-details" role="tabpanel"
              aria-labelledby="institution-details-tab">
              <div class="bg-light p-4 rounded border">
                <!-- Basic Institution Details Section -->
                <h5 class="border-bottom pb-2 mb-3">Basic Institution Details</h5>
                <div class="row">
                  <!-- Institution Type - DISABLED -->
                  <div class="col-md-4 mb-3">
                    <label>Institution Type *</label>
                    <select class="form-control" [(ngModel)]="editData.institution_type" name="institution_type"
                      (change)="onInstitutionTypeChange()" disabled>
                      <option value="1">Boys School</option>
                      <option value="2">Girls School</option>
                      <option value="3">Mixed School</option>
                    </select>
                  </div>

                  <!-- Institution Name - ENABLED with validation -->
                  <div class="col-md-4 mb-3">
                    <label>Institution Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="editData.TNT_NAME" name="TNT_NAME"
                      (input)="onInputChange()"
                      [class.is-invalid]="!editData.TNT_NAME || editData.TNT_NAME.trim() === ''">
                    <div class="invalid-feedback" *ngIf="!editData.TNT_NAME || editData.TNT_NAME.trim() === ''">
                      Institution Name is required
                    </div>
                  </div>

                  <!-- Email - ENABLED with validation -->
                  <div class="col-md-4 mb-3">
                    <label>Email <span class="text-danger">*</span></label>
                    <input type="email" class="form-control kemis-input" id="contactEmail" name="contactEmail"
                      placeholder="Enter email address" [(ngModel)]="editData.email" (blur)="validateEmail($event)"
                      (change)="checkEmail($event)" (input)="onInputChange()"
                      [class.is-invalid]="!editData.email || editData.email.trim() === ''">
                    <div class="invalid-feedback" *ngIf="!editData.email || editData.email.trim() === ''">
                      Email is required
                    </div>
                  </div>

                  <!-- Mobile Number - ENABLED with validation -->
                  <div class="col-md-4 mb-3">
                    <label>Mobile Number <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="editData.mobileno" name="mobileno"
                      (input)="onInputChange()"
                      [class.is-invalid]="!editData.mobileno || editData.mobileno.trim() === ''">
                    <div class="invalid-feedback" *ngIf="!editData.mobileno || editData.mobileno.trim() === ''">
                      Mobile Number is required
                    </div>
                  </div>

                  <!-- Onboarding Date - DISABLED -->
                  <div class="col-md-4 mb-3">
                    <label>Onboarding Date</label>
                    <input type="text" class="form-control" [value]="(editData.TNT_CREATEDDATE | date:'dd-MM-yyyy')"
                      disabled>
                  </div>

                  <!-- Have a Valid Registration Certificate - DISABLED -->
                  <div class="col-md-4 mb-3">
                    <label>Have a Valid Registration Certificate?</label>
                    <select class="form-control" [(ngModel)]="editData.is_valid_certificate" name="is_valid_certificate"
                      disabled>
                      <option [value]="true">YES</option>
                      <option [value]="false">NO</option>
                    </select>
                  </div>

                  <!-- Institution Certificate Number - DISABLED -->
                  <div class="col-md-4 mb-3" *ngIf="editData.is_valid_certificate==true">
                    <label>Institution Certificate Number</label>
                    <input type="text" class="form-control" [(ngModel)]="editData.registration_no"
                      name="registration_no" disabled>
                  </div>

                  <!-- Institution Certificate - DISABLED -->
                  <div class="col-md-4 mb-3" *ngIf="editData.is_valid_certificate==true">
                    <label>Institution Certificate</label>
                    <input type="file" (change)="changeFileForMultiple($event,1)" class="form-control" #fileInputRef1
                      disabled />
                    <small class="text-muted">File must be in PDF format only and file size less than 8MB.</small>
                    <div class="mt-1" *ngIf="editData?.tnt_registration_certificate">
                      <a [href]="getFileUrl(editData.tnt_registration_certificate)" target="_blank"
                        class="text-primary text-decoration-underline">
                        View Current Certificate
                      </a>
                    </div>
                  </div>

                  <!-- Edit mode: Show Boys fields if institution type is 1 (Boys) or 3 (Mixed) -->
                  <ng-container *ngIf="editData.institution_type == 1 || editData.institution_type == 3">
                    <!-- Number of Boys Learners - ENABLED -->
                    <div class="col-md-4 mb-3">
                      <label>Number of Boys Learners</label>
                      <input type="number" class="form-control" [(ngModel)]="editData.tnt_boys_capacity"
                        name="tnt_boys_capacity" (change)="calculateTotalLearners()" (keyup)="calculateTotalLearners()"
                        (input)="onInputChange()">
                    </div>

                    <!-- Number of SNE Boys - ENABLED -->
                    <div class="col-md-4 mb-3">
                      <label>Number of SNE Boys</label>
                      <input type="number" class="form-control" [(ngModel)]="editData.tnt_sne_boyscapacity"
                        name="tnt_sne_boyscapacity" (change)="calculateTotalLearners()"
                        (keyup)="calculateTotalLearners()" (input)="onInputChange()">
                    </div>
                  </ng-container>

                  <!-- Edit mode: Show Girls fields if institution type is 2 (Girls) or 3 (Mixed) -->
                  <ng-container *ngIf="editData.institution_type == 2 || editData.institution_type == 3">
                    <!-- Number of Girls Learners - ENABLED -->
                    <div class="col-md-4 mb-3">
                      <label>Number of Girls Learners</label>
                      <input type="number" class="form-control" [(ngModel)]="editData.tnt_girls_capacity"
                        name="tnt_girls_capacity" (change)="calculateTotalLearners()" (keyup)="calculateTotalLearners()"
                        (input)="onInputChange()">
                    </div>

                    <!-- Number of SNE Girls - ENABLED -->
                    <div class="col-md-4 mb-3">
                      <label>Number of SNE Girls</label>
                      <input type="number" class="form-control" [(ngModel)]="editData.tnt_sne_girlscapacity"
                        name="tnt_sne_girlscapacity" (change)="calculateTotalLearners()"
                        (keyup)="calculateTotalLearners()" (input)="onInputChange()">
                    </div>
                  </ng-container>

                  <!-- Total Number of Learners - DISABLED -->
                  <div class="col-md-4 mb-3">
                    <label>Total Number of Learners</label>
                    <input type="number" class="form-control" [(ngModel)]="editData.tnt_sne_capacity"
                      name="tnt_sne_capacity" style="font-weight: bold;" disabled>
                  </div>

                  <!-- Latitude - DISABLED -->
                  <div class="col-md-4 mb-3">
                    <label>Latitude</label>
                    <input type="text" class="form-control" [(ngModel)]="editData.latitude" name="latitude" readonly>
                  </div>

                  <!-- Longitude - DISABLED -->
                  <div class="col-md-4 mb-3">
                    <label>Longitude</label>
                    <input type="text" class="form-control" [(ngModel)]="editData.longitude" name="longitude" readonly>
                  </div>

                  <!-- Accommodation Type - DISABLED -->
                  <div class="col-md-4 mb-3">
                    <label>Accommodation Type</label>
                    <select class="form-control" [(ngModel)]="editData.accommodation_type" name="accommodation_type"
                      disabled>
                      <option value="1">Day School</option>
                      <option value="2">Boarding School</option>
                      <option value="3">Day & Boarding</option>
                    </select>
                  </div>
                </div>

                <!-- Location Information - DISABLED -->
                <h5 class="border-bottom pb-2 mb-3 mt-3">Location Information</h5>
                <div class="row">
                  <!-- County - DISABLED -->
                  <div class="col-md-4 mb-3">
                    <label>County *</label>
                    <select class="form-control" [(ngModel)]="editData.TNT_CONCURRENT_AVSESSIONS" name="counties_id"
                      (change)="onCountyChange($event)" disabled>
                      <option [value]="0">Select County</option>
                      <option *ngFor="let county of County" [value]="county.COUNTIES_ID">{{
                        county.COUNTIES_NAME }}</option>
                    </select>
                  </div>

                  <!-- Sub County - DISABLED -->
                  <div class="col-md-4 mb-3">
                    <label>Sub County *</label>
                    <select class="form-control" [(ngModel)]="editData.TNT_USERSPERSESSION" name="sub_counties_name"
                      (change)="onSubCountyChange($event)" disabled>
                      <option [value]="">Select Sub County</option>
                      <option *ngFor="let sub of subCounty" [value]="sub.sub_counties_id">{{
                        sub.sub_counties_name }}</option>
                    </select>
                  </div>

                  <!-- Constituency - DISABLED -->
                  <div class="col-md-4 mb-3">
                    <label>Constituency</label>
                    <select class="form-control" [(ngModel)]="editData.constituency" name="constituency"
                      (change)="onConstituencyChange($event)" disabled>
                      <option [value]="">Select Constituency</option>
                      <option *ngFor="let con of Constituency" [value]="con.con_counties_id">{{
                        con.con_counties_name }}</option>
                    </select>
                  </div>
                </div>

                <h5 class="border-bottom pb-2 mb-3 mt-3">Other Information</h5>
                <div class="row">
                  <!-- Institution Level - ENABLED with change detection -->
                  <div class="col-md-4 mb-3">
                    <label>Institution Level <span class="text-danger">*</span></label>
                    <select class="form-control" [(ngModel)]="editData.schoollevel" name="schoollevel"
                      [disabled]="studentCount > 0" (change)="onInputChange()"
                      [class.is-invalid]="!editData.schoollevel && studentCount > 0">
                      <option *ngFor="let level of SchoolList" [value]="level.LEVEL_ID">
                        {{ level.LEVEL_NAME }}
                      </option>
                    </select>
                  </div>

                  <!-- Application Type (School Category) - ENABLED with validation -->
                  <div class="col-md-4 mb-3">
                    <label>Application Type <span class="text-danger">*</span></label>
                    <select class="form-control" [(ngModel)]="editData.school_category_id" name="school_category_id"
                      (change)="onSchoolCategoryChange($event)" (input)="onInputChange()"
                      [class.is-invalid]="!editData.school_category_id || editData.school_category_id === '' || editData.school_category_id === '0'">
                      <option value="" disabled selected hidden>Select Application Type</option>
                      <option *ngFor="let item of categories" [value]="item.SCHOOL_CATEGORY_ID">
                        {{ item.SCHOOL_CATEGORY_NAME }}
                      </option>
                    </select>
                    <div class="invalid-feedback"
                      *ngIf="!editData.school_category_id || editData.school_category_id === '' || editData.school_category_id === '0'">
                      Application Type is required
                    </div>
                  </div>

                  <!-- Integrated (SNE Categories) - ENABLED for selection with validation -->
                  <div class="col-md-4 mb-3" *ngIf="shouldShowIntegratedField()">
                    <label>Integrated <span class="text-danger">*</span></label>
                    <ng-multiselect-dropdown [placeholder]="'Select Categories'" [data]="sneCategoriesList"
                      [(ngModel)]="selectedSneDetails" (ngModelChange)="onSneDetailChange($event)"
                      [settings]="dropdownSettings" [ngModelOptions]="{ standalone: true }"
                      class="form-control kemis-input" [class.is-invalid]="selectedSneDetails.length === 0">
                    </ng-multiselect-dropdown>
                    <div class="invalid-feedback" *ngIf="selectedSneDetails.length === 0">
                      At least one SNE Category is required
                    </div>
                  </div>

                  <!-- Sub Category - ENABLED for selection -->
                  <div class="col-md-4 mb-3" *ngIf="showSubSneDropdown">
                    <label>Sub Category</label>
                    <ng-multiselect-dropdown [placeholder]="'Select Sub-Categories'" [data]="subSneCategoriesList"
                      [(ngModel)]="selectedSubSneDetails" (ngModelChange)="onSubSneDetailChange($event)"
                      [settings]="subDropdownSettings" [ngModelOptions]="{ standalone: true }"
                      class="form-control kemis-input">
                    </ng-multiselect-dropdown>
                  </div>

                  <!-- School Category (Public/Private) - DISABLED -->
                  <div class="col-md-4 mb-3">
                    <label>School Category</label>
                    <select class="form-control" [(ngModel)]="editData.applicationtype" name="applicationtype" disabled>
                      <option *ngFor="let item of ApplicationType" [value]="item.applicationtype_id">
                              {{ item.applicationtype_name }}
                            </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tab 2: Logo Upload (only logo upload section) -->
            <div class="tab-pane fade" id="logo-upload" role="tabpanel" aria-labelledby="logo-upload-tab">
              <div class="bg-light p-4 rounded border">
                <div class="row">
                  <div class="col-md-12">
                    <h5 class="border-bottom pb-2 mb-3">Institution Logo</h5>
                  </div>
                  <div class="col-md-12">
                    <div class="row align-items-center">
                      <div class="col-md-4">
                        <div class="border rounded p-2 text-center bg-white"
                          style="min-height: 120px; display: flex; align-items: center; justify-content: center;">
                          <img *ngIf="previewUrl" [src]="previewUrl" style="max-width: 100%; max-height: 100px;"
                            alt="Logo Preview">
                          <span *ngIf="!previewUrl" class="text-muted">No Logo Uploaded</span>
                        </div>
                      </div>
                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-12 mb-2">
                            <label class="fw-bold">Upload Logo</label>
                            <input type="file" class="form-control" (change)="changeFile($event)" #fileInputRef
                              accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG">
                            <small class="text-muted">Allowed formats: JPG, JPEG, PNG</small>
                          </div>
                          <div class="col-md-12">
                            <button class="btn btn-primary" (click)="upload()" [disabled]="!file">
                              Upload Logo
                            </button>
                            <button type="button" class="btn btn-secondary ms-2" (click)="clearFileInput()">
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="bg-light mt-4 p-4 rounded border">
                <div class="row">
                  <div class="col-md-12">
                    <h5 class="border-bottom pb-2 mb-3">Head of Institution</h5>
                  </div>
                  <div class="col-md-12">
                    <div class="row align-items-end">
                      <div class="col-md-10">
                        <input type="text" class="form-control" [(ngModel)]="editData.firstname" name="firstName"
                          placeholder="Enter HOI Name">
                      </div>
                      <div class="col-md-2">
                        <button class="btn btn-primary w-100" (click)="submitName()">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" id="editModal" class="btn btn-secondary" data-bs-dismiss="modal"
          (click)="closeEditModal()">Close</button>
        <!-- Submit button - with full validation -->
        <button type="button" class="btn btn-primary" (click)="updateInstitution()"
          [disabled]="isUpdating || !hasChanges || !isFormValid()" *ngIf="activeTab === 'details'">
          <span *ngIf="isUpdating" class="spinner-border spinner-border-sm me-2"></span>
          {{ isUpdating ? 'Updating...' : 'Submit' }}
        </button>
      </div>
    </div>
  </div>
</div>